// 美豆剩余

import React from 'react';
import Modal from '../modal';
import { getIncomeSource } from '@/utils/vip';
import { useAtom } from 'jotai';
import { cutoutInfoAtom } from '@/store';
import { CutoutNumberType } from '@/services/user/index.d';

import styles from './index.module.css';

interface IProps {
  visible: boolean;
  onClose?: () => void;
}

const CutoutCountInfoModal: React.FC<IProps> = ({ visible, onClose }) => {
  const [cutoutInfo] = useAtom(cutoutInfoAtom);
  return (
    <Modal
      visible={visible}
      wrapStyle={{
        borderRadius: getIncomeSource() !== 'MTXX-WEB' ? 0 : '0 12px 12px 0',
        cursor: 'default',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      }}
      style={{ width: 400, height: 'auto' }}
      onClose={onClose}
    >
      <div className={styles.modalTitle}>剩余下载张数</div>
      <div className={styles.modalSubTitle}>优先消耗临期张数</div>
      <div className={styles.modalList}>
        {/* 过滤已过期的 */}
        {cutoutInfo?.details
          ?.filter((item) => !(item.type === CutoutNumberType.TIMELIMIT && item.days_left < 1))
          ?.sort((a, b) => {
            if (b.type === a.type) {
              return a.days_left - b.days_left;
            } else {
              return b.type - a.type;
            }
          })
          ?.map((item, index) => (
            <div className={styles.modalRow} key={index}>
              <div className={styles.modalRowLabel}>
                {item.type === CutoutNumberType.PERMANENT
                  ? '永久有效'
                  : `${item.days_left}天后过期`}
              </div>
              <div className={styles.modalRowValue}>
                {item.num_left} <span className={styles.unit}>张</span>
              </div>
            </div>
          ))}
      </div>
      <div className={styles.modalTips}>
        <div>消耗张数时机：</div>
        <div>1、你在抠图编辑器内下载抠完的图片时，我们将根据下载图片张数进行计算扣除。</div>
        <div>2、未重新处理过的图片、未产生抠图的图片进行反复下载，将不会扣除张数。</div>
      </div>
      <div className={styles.modalBtn} onClick={onClose}>
        好的
      </div>
    </Modal>
  );
};

export default React.memo(CutoutCountInfoModal);
